import { create } from 'zustand';
import { AppSettings, DEFAULT_SETTINGS } from '@/types/settings';
import { getStorageItem, setStorageItem } from '@/utils/storage';

interface SettingsState {
  settings: AppSettings;
  updateSettings: (newSettings: Partial<AppSettings>) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  settings: getStorageItem('appSettings', DEFAULT_SETTINGS),
  
  updateSettings: (newSettings) => {
    set((state) => {
      const updatedSettings = { ...state.settings, ...newSettings };
      setStorageItem('appSettings', updatedSettings);
      return { settings: updatedSettings };
    });
  },
}));